export default () => {
  // Listening to post messages from Apetito Menu dashboard.
  window.addEventListener('message', (event) => {
    if (event.data === 'MenuUpdated') {
      location.reload();
    }
  });
};
